/* eslint-disable */
import Oidc from "oidc-client";
import $ from "jquery";

import "babel-polyfill";
import { Alert } from "bootstrap";
import { locale } from "core-js";
let config = require("./config/config");

var mgr = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore({ store: localStorage }),
  authority: config.authority,
  client_id: "hpapp",
  code_challenge_method: "S256",
  redirect_uri: window.location.origin + "/callback.html",
  response_type: "code",
  scope: "hpapi openid", //hpapi //hrhapp
  code_challenge: "lX0rbnmIwLydcYcGvPUpPQfIWaOYGvSBL5QH2ZBeBUo",
  post_logout_redirect_uri: "http://happypurim.com",
  silent_redirect_uri: window.location.origin + "/public/silent-renew.html",
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: false,
  filterProtocolClaims: true,
  loadUserInfo: true,
  SignedOutRedirectUri: "http://happypurim.com",
  SignedOutCallbackPath: "/test",
});

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;

mgr.events.addUserLoaded(function(user) {
  //console.log('New User Loaded：', arguments);
  //console.log('Acess_token: ', user.access_token)
});

mgr.events.addAccessTokenExpiring(function() {
  //console.log('AccessToken Expiring：', arguments);
});

mgr.events.addAccessTokenExpired(function() {
  //console.log('AccessToken Expired：', arguments);
  alert("Session expired. Going out!");
  mgr
    .signoutRedirect()
    .then(function(resp) {
      //console.log('signed out', resp);
      localStorage.clear();
    })
    .catch(function(err) {
      console.log(err);
    });
});

mgr.events.addSilentRenewError(function() {
  //console.error('Silent Renew Error：', arguments);
});

mgr.events.addUserSignedOut(function() {
  alert("Going out!");
  //console.log('UserSignedOut：', arguments);
  mgr
    .signoutRedirect()
    .then(function(resp) {
      //console.log('signed out', resp);
    })
    .catch(function(err) {
      console.log(err);
    });
});

export default class AuthService {
  logMeout(token) {
    let self = this;
    let url = "https://localhost:5001/connect/endsession?id_token_hint=";
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            console.log(user);
            url =
              url +
              user.id_token +
              "&post_logout_redirect_uri=" +
              encodeURI("http://localhost:8081");
            window.open(url, "_self");
            // $.get(url, function (data, status) {
            // 	alert("Data: " + data + "\nStatus: " + status);

            // });
            // mgr.signinRedirect({
            // 	extraQueryParams: {
            // 		token: token
            // 	},

            // }).then(function (res) {
            // 	//	console.log("res s", res)

            // }).catch(function (err) {
            // 	console.log(err)
            // })
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });

    // return new Promise((resolve, reject) => {
    // 	mgr.revokeAccessToken().then(function (user) {

    // 		alert(user)

    // 		mgr.signinRedirect({
    // 			extraQueryParams: {
    // 				token: 'BEE93487-1B78-4810-9B33-74D002895D4C'
    // 			},

    // 		  }).then(function (res) {
    // 			  //	console.log("res s", res)

    // 			  }).catch(function (err) {
    // 				  console.log(err)
    // 			  })
    // 	}).catch(function (err) {
    // 		console.log(err)
    // 		return reject(err)
    // 	});
    // })
    // 	GET https://idsvr.example.com/session/logout
    // ?id_token_hint=id_token_issued_to_client
    // &post_logout_redirect_uri=https://client1.example.com/logged_out
    // &state=random_string
  }
  // Renew the token manually
  renewToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .signinSilent()
        .then(function(user) {
          if (user == null) {
            self.signIn(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user who is logged in
  getUser() {
    let self = this;

    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          console.log("user ", user);
          // alert(user)
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Check if there is any user logged in
  getSignedIn() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Redirect of the current window to the authorization endpoint.
  signIn() {
    mgr
      .signinRedirect()
      .then(function(res) {
        //	console.log("res s", res)
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  // Redirect of the current window to the end session endpoint
  signOut() {
    //console.log("u clicked me")

    mgr
      .signoutRedirect({
        extraQueryParams: {
          token: "http://localhost:8081",
        },
      })
      .then(function(resp) {
        console.log("signed out", resp);
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  // Get the profile of the user logged in
  getProfile() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the token id
  getIdToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.id_token);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the session state
  getSessionState() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.session_state);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the access token of the logged in user
  getAcessToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          // console.log("user", user)
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.access_token);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Takes the scopes of the logged in user
  getScopes() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.scopes);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  signOutAsync() {}

  async startSigninClient(token) {
    if (token) {
      mgr
        .signinRedirect({
          extraQueryParams: {
            token: token,
          },
        })
        .then(function(res) {
          //	console.log("res s", res)
        })
        .catch(function(err) {
          console.log(err);
        });
    }

    //   if(token){
    // 	mgr.getUser()
    //   }
  }

  // Get the user roles logged in
  getRole() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile.role);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }
}
